// extracted by mini-css-extract-plugin
export default {"productGallery":"vJ-z","inQuickShop":"wJ-z"};